const NOTEBOOK_PATH =
  "M25.4793 7H11.7993C10.9598 7 10.2793 7.65665 10.2793 8.46667V27.5333C10.2793 28.3434 10.9598 29 11.7993 29H25.4793C26.3188 29 26.9993 28.3434 26.9993 27.5333V8.46667C26.9993 7.65665 26.3188 7 25.4793 7Z";
const RING_LINES_PATH = "M8 12.1333H12.56M8 18H12.56M8 23.8666H12.56";
const TEXT_LINES_PATH =
  "M15.5996 13.6001H23.1996M15.5996 18.0001H23.1996M15.5996 22.4001H20.1596";

/**
 * Design Scope glyph — ruled notebook, no tile. Drawn with lines, so the
 * colour comes from a `stroke-*` class in `className` (use `stroke-current`
 * to follow the surrounding text colour).
 */
export default function DesignScopeCiqIcon({
  size = 12,
  className = "stroke-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="6.5 6 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={opacity}
      >
        <path d={NOTEBOOK_PATH} />
        <path d={RING_LINES_PATH} />
        <path d={TEXT_LINES_PATH} />
      </g>
    </svg>
  );
}

/**
 * Design Scope badge — the same glyph on its fixed-colour tile.
 * Design: 36×36 container (#337CD7) + glyph (#ABCFE2). Used by CiqIconBox.
 */
export function DesignScopeTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#337CD7" />
      <g
        stroke="#ABCFE2"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Filled with the tile colour so the ring ticks read as passing behind the cover. */}
        <path d={NOTEBOOK_PATH} fill="#337CD7" />
        <path d={RING_LINES_PATH} />
        <path d={TEXT_LINES_PATH} />
      </g>
    </svg>
  );
}
